import axios from "axios";
import { DataGrid } from "devextreme-react";
import CustomStore from "devextreme/data/custom_store";
import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { getDateString } from "../../../../common/date";
import {
  Column,
  Editing,
  FilterRow,
  HeaderFilter,
  LoadPanel,
  Lookup,
  Paging,
  RequiredRule,
  Scrolling,
  SearchPanel,
  Selection,
  Sorting,
} from "devextreme-react/data-grid";
import { PTCCategory } from "../../data";

export default function PTCPolicyGrid(props) {
  const { contrNo, mode } = props;

  const userInfo = useSelector((state) => state.userInfo);

  const [dataSource, setDataSource] = useState(
    new CustomStore({
      key: ["cat", "SEQ"],
      load: async () => {
        // [R11]
        const result = await axios.get(
          `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/paytStatus/ptcPolicy/${contrNo}`
        );

        return result.data;
      },
      insert: async (values) => {
        await axios.post(
          `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/paytStatus/ptcPolicy/${contrNo}/${values.cat}`,
          values
        );
      },
      update: async (key, values) => {
        values.writer = userInfo.employeeNo;
        values.date = getDateString(new Date());

        await axios.put(
          `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/paytStatus/ptcPolicy/${contrNo}/${key.cat}/${key.SEQ}`,
          values
        );
      },
      remove: async (key) => {
        await axios.delete(
          `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/paytStatus/ptcPolicy/${contrNo}/${key.cat}/${key.SEQ}`
        );
      },
    })
  );

  const calculateDisplayValue = (data) => {
    return `${data.name} (${data.writer})`;
  };

  const onInitNewRow = (e) => {
    e.data.writer = userInfo.employeeNo;
    e.data.name = userInfo.name;
    e.data.date = getDateString(new Date());
  };

  // const onEditingStart = (e) => {
  //   console.debug("[onEditingStart]");
  //   console.debug("e", e);

  //   // e.data.writer = userInfo.employeeNo;
  //   // e.data.name = userInfo.name;
  //   // e.data.date = getDateString(new Date());

  //   const item = e.component._controllers.data._allItems.find(
  //     (item) => item.key.cat == e.data.cat && item.key.SEQ == e.data.SEQ
  //   );

  //   console.debug("item", item);

  //   item.data.writer = userInfo.employeeNo;
  //   item.data.name = userInfo.name;
  //   item.data.date = getDateString(new Date());
  // };

  return (
    <DataGrid
      dataSource={dataSource}
      keyExpr={["contrNo", "cat"]}
      showBorders={true}
      allowColumnReordering={true}
      allowColumnResizing={true}
      rowAlternationEnabled={true}
      showRowLines={true}
      showColumnLines={true}
      width={"100%"}
      height={"auto"}
      style={{
        maxHeight: "calc(100vh - 145px)",
      }}
      repaintChangesOnly={true}
      highlightChanges={true}
      columnAutoWidth={true}
      wordWrapEnabled={true}
      //   onContentReady={onContentReady}
      onInitNewRow={onInitNewRow}
      // onEditingStart={onEditingStart}
    >
      <SearchPanel visible={true} highlightCaseSensitive={true} width={240} />
      <Scrolling
        mode={"virtual"}
        rowRenderingMode={"virtual"}
        columnRenderingMode={"virtual"}
        showScrollbar={"always"}
      />
      <LoadPanel enabled={true} />
      <HeaderFilter visible={true} />
      <FilterRow visible={true} applyFilter={"auto"} />
      <Paging enabled={false} />
      <Sorting mode={"multiple"} />
      <Selection mode={"single"} />
      <Editing
        mode={"batch"}
        allowAdding={mode == "read" ? false : true}
        allowUpdating={mode == "read" ? false : true}
        allowDeleting={mode == "read" ? false : true}
        selectTextOnEditStart={true}
        startEditAction={"dblClick"}
      />
      <Column
        dataField={"cat"}
        caption={"PTC Category"}
        width={120}
        showEditorAlways={true}
      >
        <Lookup
          dataSource={PTCCategory}
          valueExpr={"id"}
          displayExpr={"name"}
        />
        <RequiredRule message={"PTC category is required."} />
      </Column>
      <Column
        dataField={"agAmt"}
        caption="협의된 금액"
        format={"#0,000"}
        width={110}
        showEditorAlways={true}
      />
      <Column
        dataField={"writer"}
        caption="작성자"
        // calculateCellValue={calculateCellValue}
        calculateDisplayValue={calculateDisplayValue}
        allowEditing={false}
        width={135}
      />
      <Column
        dataField={"date"}
        caption="작성일"
        format={"yyyy-MM-dd"}
        dataType={"date"}
        allowEditing={false}
        width={95}
      />
      <Column
        dataField={"reasModAmt"}
        caption="금액 수정시 사유"
        width={200}
        showEditorAlways={true}
      />
      <Column dataField={"comment"} caption="Comment" showEditorAlways={true} />
    </DataGrid>
  );
}
